import makeStyles from '@mui/styles/makeStyles';
import colors from '../../styles/colors';

export const useStyles = makeStyles((theme) => ({
  listItemIcon: {
    minWidth: 35,
    color: theme.colors.blue,
  },
  title: {
    borderBottom: `1px solid ${colors.black}`,
    padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
    flexDirection: 'row',
    alignItems: 'center',
    display: 'flex',
  },
  popper: {
    zIndex: 100000,
    backgroundColor: theme.palette.background.paper,
    boxShadow: '2px 2px 4px rgba(0,0,0,0.5)',
  },
  icon: {
    color: theme.palette.text.primary,
  },
}));
